import { createApi } from '@reduxjs/toolkit/query/react'
import axiosBaseQuery from 'api/axiosBaseQuery'

const paymentApi = createApi({
  reducerPath: 'paymentApi',
  baseQuery: axiosBaseQuery({
    baseUrl: process.env.REACT_APP_BASE_URL ?? ''
  }),
  tagTypes: ['Payment', 'PaymentList', 'PaymentSchedule'],
  endpoints: () => ({})
})

export default paymentApi
